import H5CourseCard from "@saas/pages/src/group-activity/components/H5CourseCard";
import {
  getGroupBuying,
  getCourseInfo,
} from "@saas/server-api/src/product-details";
import { mapGetters } from "vuex";
import {
  isHXApp,
  isMobile,
  clipboard,
  isMGAppInPad,
  ShareDrawer,
  isQQ,
  isWeChat,
  isH5,
} from "@saas/components/src";
import moment from "moment";
import { million } from "@saas/components/src/utils/utils";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
export default {
  data() {
    return {
      activeInfo: {
        state: 3,
        duration: 12,
        member_list: [],
      },
      courseInfo: {},
      countdown: {},
      timerId: null,
      isMobile: isMobile(),
      isMGAppInPad: false,
      isHXApp: isHXApp(),
      moment: moment,
      million: million,
      isElectron: window.isElectron,
      isWeChat: isWeChat(),
      isQQ: isQQ(),
      isH5: isH5(),
    };
  },
  computed: {
    userLength() {
      let member = this.activeInfo?.member_list?.length || 0;
      return member + this.couldJoinNum;
    },
    activeId() {
      return this.$route.params.id;
    },
    // 待成团 1
    NO_GROUP: () => 1,
    // 拼团成功 2
    GROUP_SUCCESS: () => 2,
    // 拼团失败 3
    GROUP_FAIL: () => 3,
    ...mapGetters(["user"]),
    // 拼团结果
    groupResultLabel() {
      if (this.activeInfo.state === this.NO_GROUP) {
        if (this.myOrderInfo.state === 1) {
          return "待支付";
        } else if (this.myOrderInfo.state === 2) {
          return "付款成功";
        } else if (this.myOrderInfo.state === 4) {
          return "已退款";
        } else {
          return "";
        }
      } else if (this.activeInfo.state === this.GROUP_SUCCESS) {
        if (this.myOrderInfo.state === 1) {
          return "待支付";
        } else if (this.myOrderInfo.state === 2) {
          return "拼团成功";
        } else if (this.myOrderInfo.state === 4) {
          return "已退款";
        } else {
          return "";
        }
      } else if (this.activeInfo.state === this.GROUP_FAIL) {
        return "拼团失败";
      } else {
        return "";
      }
    },
    // 我的订单信息
    myOrderInfo() {
      // 数组筛选出当前用户信息，取符合条件的最后一个
      const list = this.activeInfo.member_list || [];
      const reverseList = Array.from(list).reverse();
      const info = reverseList.find(
        (item) => item.user_id === this.user?.user_id
      );
      return info || {};
    },
    // 拼团列表提示信息
    userListMessage() {
      if (this.activeInfo.state === this.NO_GROUP) {
        // 待成团
        return `再邀 <span style="color: #F03349">${this.couldJoinNum}</span>  人，人满后可开通课程`;
      } else if (this.activeInfo.state === this.GROUP_SUCCESS) {
        return `已满<span style="color: #F03349"> ${this.activeInfo.group_num}</span> 人成团`;
      } else if (this.activeInfo.state === this.GROUP_FAIL) {
        return "退款将原路返回";
      } else {
        return "";
      }
    },
    // 待加入人数, 成团要求人数-已支付未退款用户人数
    couldJoinNum() {
      if (this.activeInfo.state === this.NO_GROUP) {
        const list = (this.activeInfo.member_list || []).filter(
          (item) => item.state === 2
        );
        const num = this.activeInfo.group_num - list.length;
        return num > 0 ? num : 0;
        // }
        // else if (
        //   this.activeInfo.state === this.GROUP_SUCCESS &&
        //   this.activeInfo.exceed_group === 1
        // ) {
        //   // 拼团成功，并且可以超员成团
        //   return 1;
      } else {
        return 0;
      }
    },
    // 课程标签
    courseTag() {
      return (this.courseInfo.goods?.goods_tag || "").split(",");
    },
  },
  mounted() {
    this.isMGAppInPad = isMGAppInPad();
    this.getDetails();
    document.title = "拼团详情";
    if (this.isHXApp) {
      jsToFlutter("setTitle", { title: `拼团详情` });
    }
  },
  beforeDestroy() {
    this.stopCountdown();
  },
  methods: {
    getDetails() {
      getGroupBuying({
        id: this.activeId,
      }).then((res) => {
        if (res.code === 1) {
          this.activeInfo = res.data;
          if (!res.data.is_join_group) {
            this.$router.push("/product-detail/" + res.data.course_id);
          } else {
            if (res.data.state === this.NO_GROUP) {
              this.startCountdown(res.data.end_at * 1000);
            }
            this.getCourseInfo();
          }
        }
      });
    },
    getCourseInfo() {
      getCourseInfo({
        course_id: this.activeInfo.course_id,
      }).then((res) => {
        if (res.code === 1) {
          this.courseInfo = res.data;
          let pageTitle = `拼团-${this.courseInfo.course_name}`;
          document.title = pageTitle;
          if (this.isHXApp) {
            jsToFlutter("setTitle", {
              title: `拼团-${this.courseInfo.course_name}`,
            });
          }
        }
      });
    },
    startCountdown(targetDateString) {
      this.stopCountdown(); // 防止重复启动
      this.timerId = setInterval(() => {
        this.countdown = this.calculateCountdown(targetDateString);
        if (this.countdown === null) {
          // 拼团失败
          this.activeInfo.state = this.GROUP_FAIL;
          this.activeInfo.member_list.forEach((item) => {
            item.state = item.state === 2 ? 4 : item.state;
          });
        }
      }, 1000);
    },
    stopCountdown() {
      clearInterval(this.timerId);
      this.timerId = null;
    },
    calculateCountdown(dateString) {
      const targetDate = new Date(dateString);
      const now = new Date();
      const difference = targetDate.getTime() - now.getTime();

      if (difference <= 0) {
        this.stopCountdown();
        return null;
      }

      const totalHours = Math.floor(difference / (1000 * 60 * 60));
      const hours = totalHours % 24;
      const minutes = Math.floor((difference / 1000 / 60) % 60);
      const seconds = Math.floor((difference / 1000) % 60);

      // 如果总小时数超过24小时，直接展示总小时数
      return totalHours >= 24
        ? {
            hours: totalHours < 10 ? "0" + totalHours : totalHours,
            minutes: minutes < 10 ? "0" + minutes : minutes,
            seconds: seconds < 10 ? "0" + seconds : seconds,
          }
        : {
            hours: hours < 10 ? "0" + hours : hours,
            minutes: minutes < 10 ? "0" + minutes : minutes,
            seconds: seconds < 10 ? "0" + seconds : seconds,
          };
    },
    // 查看更多优惠课程
    handleViewMore() {
      if (this.isHXApp) {
        // 跳转app首页
        jsToFlutter("toMain", { index: 0 });
      } else {
        this.$router.push("/");
      }
    },
    // 邀请好友
    handleApply() {
      const content = `点击链接，一起 ${
        this.activeInfo.group_price / 100
      } 元拼团购买原价 ${this.courseInfo.goods?.price / 100} 元的课程《${
        this.courseInfo.course_name
      }》，链接：${process.env.VUE_APP_SAAS_WEB_URL}/group-share/${
        this.activeId
      }`;
      const _this = this;
      clipboard(content, () => {
        _this.$message.success("链接已复制，可以发给好友啦");
      });
    },
    // 查看课程
    handleViewCourse() {
      this.$router.push("/product-detail/" + this.activeInfo.course_id);
    },
    handleClickArrow(type) {
      if (type === "left") {
        this.$nextTick(() => {
          this.$refs.userList.scrollLeft -= 400;
        });
      } else {
        this.$refs.userList.scrollLeft += 400;
      }
    },
    back() {
      window.history.go(-1);
    },
  },
  components: {
    H5CourseCard,
    ShareDrawer,
  },
};
